(function () {
    'use strict';

    var component = {
        transclude: true,
        templateUrl:
            'app/js/components/helpers/months-dropdown-component/months-dropdown.html',
        controller: controller,
        controllerAs: "vmMD",
        bindings: {
            ngModel: '=',
            ngRequired: '='
        }
    };

    iteroComponents.component('monthsDropdown', component);

    function controller(gettextCatalog, gettext) {
        this.months = [
            {
                "value": 1,
                "text": gettextCatalog.getString(gettext("January"))
            },
            {
                "value": 2,
                "text": gettextCatalog.getString(gettext("February"))
            },
            {
                "value": 3,
                "text": gettextCatalog.getString(gettext("March"))
            },
            {
                "value": 4,
                "text": gettextCatalog.getString(gettext("April"))
            },
            {
                "value": 5,
                "text": gettextCatalog.getString(gettext("May"))
            },
            {
                "value": 6,
                "text": gettextCatalog.getString(gettext("June"))
            },
            {
                "value": 7,
                "text": gettextCatalog.getString(gettext("July"))
            },
            {
                "value": 8,
                "text": gettextCatalog.getString(gettext("August"))
            },
            {
                "value": 9,
                "text": gettextCatalog.getString(gettext("September"))
            },
            {
                "value": 10,
                "text": gettextCatalog.getString(gettext("October"))
            },
            {
                "value": 11,
                "text": gettextCatalog.getString(gettext("November"))
            },
            {
                "value": 12,
                "text": gettextCatalog.getString(gettext("December"))
            }
        ]
    }
})();